import {
    SHOW_DELETE_MY_ACCOUNT,
    SHOW_CONTACT_US,
    SHOW_TERMS_OF_USE,
    SHOW_PROFILE
} from 'shared/actions/types';

export const showDeleteMyAcc = (url) => dispatch => {
    dispatch({
        type: SHOW_DELETE_MY_ACCOUNT,
        payload: url
    });
}

export const showTerms = (url) => dispatch => {
    dispatch({
        type: SHOW_TERMS_OF_USE,
        payload: url
    });
}

export const showContactUs = (url) => dispatch => {
    dispatch({
        type: SHOW_CONTACT_US,
        payload: url
    });
}

export const backToProfile = (url) => dispatch => {
    dispatch({
        type: SHOW_PROFILE
    });
}
